<div class="vpc_container" *ngIf="role">
  <div class="text_bold">
    {{role.name}}
  </div>
  <div *ngIf="role.arn" class="text_bold">
    {{role.arn}}
  </div>
</div>